<template>
  <div class="cheat-scroll-wrapper">
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form class="form" @submit.prevent="handleSubmit(handleCheatExam)">
        <div class="cheat-container">
          <table class="cheat-table" style="width: 100%; border-collapse: collapse;">
            <thead>
            <tr>
              <th style="white-space: nowrap; min-width: 110px">Mã Học Viên</th>
              <th style="white-space: nowrap; min-width: 180px">Tên Học Viên</th>
              <th v-if="!isEntrance" style="white-space: nowrap; min-width: 100px">Mã lớp</th>
              <th style="min-width: 100px">Gian lận</th>
              <th style="width: 240px">Lý do gian lận</th>
              <th style="min-width: 200px">Chi tiết lý do</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td style="min-width: 110px">{{ item.studentId }}</td>
              <td style="min-width: 180px">{{ item.name }}</td>
              <td v-if="!isEntrance" style="min-width: 100px">{{ item.classroomId }}</td>
              <td style="min-width: 100px">
                <div
                    class="cheat-toggle"
                    :class="{ active: item.status }"
                >
                  <i v-if="item.status" class="el-icon-close" style="color: white !important;"></i>
                </div>
              </td>
              <td style="min-width: 220px">
                <el-radio-group v-model="item.cheatingState" :disabled="readOnly" @change="onCheatingStateChange(item)">
                  <el-radio :label="0">Không</el-radio>
                  <el-radio :label="1" class="cheat-state-suspected">Nghi ngờ</el-radio>
                  <el-radio :label="2" class="cheat-state-confirmed">Gian lận</el-radio>
                </el-radio-group>
              </td>
              <td style="width: 240px">
                <el-tooltip
                    v-if="item.cheating_reason_id && item.cheating_reason_id.length"
                    placement="top"
                    effect="dark"
                >
                  <div slot="content" style="white-space: pre-wrap; max-width: 300px;">
                    {{ getReasonLabels(item.cheating_reason_id).join('\n') }}
                  </div>
                  <span style="display: inline-block; width: 100%;">
                    <el-select
                        v-model="item.cheating_reason_id"
                        multiple
                        collapse-tags
                        placeholder="Chọn"
                        size="small"
                        :disabled="readOnly"
                        style="width: 100%; border: 1px solid gray; border-radius: 5px;"
                    >
                      <el-option
                          v-for="option in reasonOption"
                          :key="option.id"
                          :label="option.reason"
                          :value="option.id"
                      />
                    </el-select>
                  </span>
                </el-tooltip>
                <ValidationProvider v-else-if="item.cheatingState === 2" :vid="`cheat_reason-${index + 1}`"
                                    name="Lý do gian lận" rules="required" v-slot="{ errors }" mode="eager">
                  <el-select
                      v-model="item.cheating_reason_id"
                      multiple
                      collapse-tags
                      placeholder="Chọn"
                      size="small"
                      :disabled="readOnly"
                      style="width: 100%; border: 1px solid gray; border-radius: 5px; padding-left: 4px"
                  >
                    <el-option
                        v-for="option in reasonOption"
                        :key="option.id"
                        :label="option.reason"
                      :value="option.id"
                    />
                  </el-select>
                  <div v-if="!readOnly" class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </td>
              <td style="min-width: 200px;">
                  <el-input
                      style="min-width: 200px"
                      v-if="readOnly ? item.description : item.cheatingState !== 0"
                      v-model="item.description"
                      placeholder="Nhập lý do gian lận..."
                      size="mini"
                      :disabled="readOnly"
                      class="cheat-input"
                  />
              </td>
            </tr>
            </tbody>
          </table>
          <div class="cheat-actions">
            <el-button native-type="button" @click="closeDialog">Hủy bỏ</el-button>
            <el-button
                v-if="!readOnly"
                native-type="submit"
                style="background: #5E00B6; color: white; padding: 0 15px; border-radius: 4px"
                type="primary"
            >
              Xác nhận
            </el-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  GET_LIST_REASON_CHEAT, GET_LIST_STUDENT_CHEAT, STUDENT_CHEATING
} from "@/core/services/store/marking/marking.module";
import {StudentCheatingModel} from "../model/taskPersonal";

export default {
  name: 'HandleCheat',
  data() {
    return {
      reasonOption: [],
      tableData: [],
      examName: null,
    }
  },

  props: {
    markingExamShiftId: {
      type: Number,
      default: null,
    },
    isEntrance: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    }
  },

  mounted() {
    this.getListReasonCheating()
    this.getListCheckStudentCheating()
  },

  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },

    onCheatingStateChange(item) {
      item.status = item.cheatingState !== 0
      if (item.cheatingState !== 2) item.cheating_reason_id = []
      if (item.cheatingState === 0) item.description = ''
    },

    getListReasonCheating() {
      this.$store.dispatch(GET_LIST_REASON_CHEAT, {marking_exam_shift_id: this.markingExamShiftId}).then(res => {
        if (!res.error) {
          this.reasonOption = res.data?.gian_lan || [];
        }
      })
    },

    getListCheckStudentCheating() {
      this.$store.dispatch(GET_LIST_STUDENT_CHEAT, {marking_exam_shift_id: this.markingExamShiftId}).then(res => {
        if (!res.error) {
          this.$emit('examName', res.data[0]?.shift_name)
          this.tableData = res.data.map(item => {
            const student = new StudentCheatingModel(
                item.user_id ? item.user_id + 100000 : null,
                item.user_name ?? '',
                item.user_id ?? null,
                item.cheating_reason_id ?? [],
                item.description ?? '',
                item.marking_exam_shift_id ?? null,
                item.status ?? false,
                item.status ?? false,
                item.classroom_id ?? 0
            )
            student.cheatingState = item.status === null || item.status === undefined
              ? null
              : (Number(item.status) === 1 ? 2 : 0)
            return student
          }) ?? [];
        }
      })
    },

    getReasonLabels(ids) {
      return this.reasonOption.filter(option => ids.includes(option.id)).map(option => {
        return `- ${option.reason}`
      });
    },

    handleCheatExam() {
      if (this.readOnly) return
      const payload = this.tableData.map(item => ({
        user_id: item.user_id,
        cheating_reason_id: item.cheatingState === 2 ? (item.cheating_reason_id ?? []) : [],
        description: item.description,
        marking_exam_shift_id: item.marking_exam_shift_id,
        status: [1, 2].includes(item.cheatingState) ? 1 : 0
      }));
      this.$store.dispatch(STUDENT_CHEATING, payload).then(res => {
        if (!res.error) {
          this.$message.success('Đánh dấu học viên gian lận thành công!')
          this.closeDialog()
        }
      })
    },
  }
}
</script>

<style scoped>
.cheat-scroll-wrapper {
  overflow-x: auto;
}

.cheat-container {
  min-width: 800px;
}

.cheat-table {
  width: 100%;
  border-collapse: collapse;
}

.cheat-actions {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  margin-top: 20px;
  width: 100%;
}

.cheat-toggle {
  width: 24px;
  height: 24px;
  background-color: #dcdfe6;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
}

.cheat-toggle.active {
  background-color: #AC2626;
  color: white;
}

.cheat-table th,
.cheat-table td {
  padding: 16px 12px;
  text-align: left;
  vertical-align: middle;
}

.cheat-table th {
  background-color: #f5f7fa;
  font-weight: 600;
}

.cheat-input {
  width: 100%;
}

::v-deep .el-input__inner {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  background-color: transparent;
  padding-left: 0;
}

::v-deep(.el-select .el-select__tags) {
  max-height: 22px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.el-select >>> .el-select__tags > span {
  margin-right: 4px;
}
</style>
